export interface FilterGroupConfig {
  key: string;
  label: string;
  options: string[];
  value: string;
}

interface FilterBarProps {
  groups: FilterGroupConfig[];
  onChange: (key: string, value: string) => void;
}

export default function FilterBar({ groups, onChange }: FilterBarProps) {
  return (
    <div className="flex flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      {groups.map((group) => (
        <div key={group.key} className="flex flex-col gap-2 md:flex-row md:items-start">
          <span className="w-full shrink-0 pt-1 text-xs font-medium text-foreground-500 md:w-20">
            {group.label}
          </span>
          <div className="flex flex-wrap gap-2">
            {group.options.map((option) => {
              const active = group.value === option;
              return (
                <button
                  key={option}
                  type="button"
                  onClick={() => onChange(group.key, option)}
                  className={`px-3 py-1 rounded-full text-xs md:text-sm whitespace-nowrap transition-colors cursor-pointer ${
                    active
                      ? "bg-accent-500 text-background-50"
                      : "bg-background-100 text-foreground-700 hover:bg-secondary-100 hover:text-secondary-900"
                  }`}
                >
                  {option}
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}